const config = require('./config.json');
const environment = process.env.NUXT_ENV || 'development';
console.log(`Using config for ${environment} environment`);

export default config[environment];
